module.exports = __webpack_public_path__ + "img/inkidnIcon.28ea145.png";